module.exports = __webpack_public_path__ + "static/logo-69273fa30ecead35c02e94ad12d6f03e.png";